import type {
  HTMLAttributes,
  ReactNode,
} from 'react'
import { Inbox } from 'lucide-react'

import { cn } from '@/shared/lib/cn'

export interface EmptyStateProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title: ReactNode
  description?: ReactNode
  icon?: ReactNode
  action?: ReactNode
}

export function EmptyState({
  title,
  description,
  icon,
  action,
  className,
  ...props
}: EmptyStateProps) {
  return (
    <div
      {...props}
      className={cn(
        [
          'flex min-h-64 flex-col',
          'items-center justify-center',
          'rounded-xl border border-dashed',
          'border-(--color-border)',
          'bg-(--color-surface)',
          'px-6 py-10 text-center',
        ],
        className,
      )}
    >
      <div
        className={[
          'flex h-12 w-12',
          'items-center justify-center',
          'rounded-full',
          'bg-(--color-surface-muted)',
          'text-(--color-muted-foreground)',
        ].join(' ')}
      >
        {icon ?? (
          <Inbox
            aria-hidden="true"
            className="h-6 w-6"
          />
        )}
      </div>

      <h2 className="mt-4 text-base font-semibold">
        {title}
      </h2>

      {description ? (
        <p className="mt-2 max-w-md text-sm leading-6 text-(--color-muted-foreground)">
          {description}
        </p>
      ) : null}

      {action ? (
        <div className="mt-5">
          {action}
        </div>
      ) : null}
    </div>
  )
}